/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { SortIcon, Header } from '@blend/enterprise-components';

const { useState } = React;

const styles = StyleSheet.create({
  headerTextWrapper: {
    marginRight: 8,
  },
  headerWrapper: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    width: 'fit-content',
  },
});

export interface DocumentDataHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
  isSortedBy: boolean;
  sortDir: 'asc' | 'desc';
}

export const DocumentDataHeader: React.FC<React.PropsWithChildren<DocumentDataHeaderProps>> = props => {
  const { id, isSortedBy, sortDir, children, ...htmlDivAttr } = props;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      {...htmlDivAttr}
      className={css(styles.headerWrapper)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={css(styles.headerTextWrapper)}>
        <Header size={6}>{children}</Header>
      </div>
      <SortIcon hovered={isHovered} id={`${id}-sortIcon`} size={16} sortDir={isSortedBy ? sortDir : undefined} />
    </div>
  );
};
